import { render, staticRenderFns } from "./AverageQuantityOverTime.vue?vue&type=template&id=74abdbe2&scoped=true&"
import script from "./AverageQuantityOverTime.vue?vue&type=script&lang=js&"
export * from "./AverageQuantityOverTime.vue?vue&type=script&lang=js&"
import style0 from "./AverageQuantityOverTime.vue?vue&type=style&index=0&id=74abdbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74abdbe2",
  null
  
)

export default component.exports